/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const FreeNightsProgram = {
    MarriottStayFor5PayFor4: 'Marriott Stay for 5, Pay for 4',
    HiltonHonorsFifthNightFree: 'Hilton Honors Fifth Night Free',
    IhgOneRewardsFourthNightFree: 'IHG One Rewards Fourth Night Free'
} as const;
export type FreeNightsProgram = typeof FreeNightsProgram[keyof typeof FreeNightsProgram];


export function instanceOfFreeNightsProgram(value: any): boolean {
    for (const key in FreeNightsProgram) {
        if (Object.prototype.hasOwnProperty.call(FreeNightsProgram, key)) {
            if (FreeNightsProgram[key as keyof typeof FreeNightsProgram] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FreeNightsProgramFromJSON(json: any): FreeNightsProgram {
    return FreeNightsProgramFromJSONTyped(json, false);
}

export function FreeNightsProgramFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreeNightsProgram {
    return json as FreeNightsProgram;
}

export function FreeNightsProgramToJSON(value?: FreeNightsProgram | null): any {
    return value as any;
}

export function FreeNightsProgramToJSONTyped(value: any, ignoreDiscriminator: boolean): FreeNightsProgram {
    return value as FreeNightsProgram;
}

